var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "container w-container" },
    [
      _c(
        "w-row",
        { style: { marginTop: "5px" }, attrs: { "no-margin": "" } },
        [
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c(
                "w-row",
                { attrs: { "no-margin": "" } },
                [
                  _c("w-select", {
                    staticClass: "mr view-select",
                    style: { minWidth: "200px" },
                    attrs: {
                      value: _vm.selectedView,
                      filter: "",
                      items: _vm.viewItems,
                    },
                    on: {
                      input: function ($event) {
                        return _vm.onViewSelected($event)
                      },
                    },
                  }),
                  _c("w-input", {
                    staticClass: "mr",
                    attrs: { "icon-left": "search" },
                    on: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.fetch()
                      },
                    },
                    model: {
                      value: _vm.searchText,
                      callback: function ($$v) {
                        _vm.searchText = $$v
                      },
                      expression: "searchText",
                    },
                  }),
                  _c(
                    "w-button-bar",
                    [
                      _c(
                        "w-button",
                        {
                          attrs: { disabled: _vm.isFetching },
                          on: {
                            click: function ($event) {
                              return _vm.fetch()
                            },
                          },
                        },
                        [
                          _c("w-fa", {
                            attrs: { icon: "sync", spin: _vm.isFetching },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.contact
                    ? _c(
                        "app-tag",
                        {
                          staticClass: "ml mr mts action search-chip",
                          attrs: { icon: "times" },
                          on: {
                            click: function ($event) {
                              return _vm.toggleSupplierSearch()
                            },
                          },
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.contact.getDisplayName()) + " "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm.searchQuery
                    ? _c(
                        "app-tag",
                        {
                          staticClass: "mls mr mts action search-chip",
                          attrs: { icon: "times" },
                          on: {
                            click: function ($event) {
                              return _vm.clearSearchQuery()
                            },
                          },
                        },
                        [
                          !_vm.$wf.isMdDown
                            ? [
                                _c(
                                  "span",
                                  { staticClass: "search-chip-content" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$ct("cancelSearch", [
                                            _vm.searchQuery,
                                          ])
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            : [
                                _c("w-fa", { attrs: { icon: "search" } }),
                                _vm._v('" '),
                                _c(
                                  "span",
                                  { staticClass: "search-chip-content" },
                                  [_vm._v(" " + _vm._s(_vm.searchQuery) + " ")]
                                ),
                              ],
                        ],
                        2
                      )
                    : _vm._e(),
                  _c("w-spacer"),
                  _c(
                    "w-button-bar",
                    { staticClass: "mr" },
                    [
                      _c(
                        "w-button",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: _vm.$ct(
                                _vm.supplierFielderId != ""
                                  ? "clear-supplier"
                                  : "select-supplier"
                              ),
                              expression:
                                "$ct(supplierFielderId!='' ? 'clear-supplier' : 'select-supplier')",
                            },
                          ],
                          class: { cancel: _vm.supplierFielderId != "" },
                          on: {
                            click: function ($event) {
                              return _vm.toggleSupplierSearch()
                            },
                          },
                        },
                        [
                          _c("w-fa", {
                            staticClass: "no-margin",
                            attrs: { icon: _vm.filterOnCurrentContactIcon },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-button-bar",
                    [
                      _c(
                        "w-button",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: _vm.$ct("excel-conversion"),
                              expression: "$ct('excel-conversion')",
                            },
                          ],
                          on: {
                            click: function ($event) {
                              return _vm.openExcelMapper()
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "file-excel" } })],
                        1
                      ),
                      _c(
                        "w-button",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: _vm.$ct("import-csv"),
                              expression: "$ct('import-csv')",
                            },
                          ],
                          on: {
                            click: function ($event) {
                              _vm.importModalOpen = true
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "upload" } })],
                        1
                      ),
                      _c(
                        "w-button",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: _vm.$ct("delete-selected-items"),
                              expression: "$ct('delete-selected-items')",
                            },
                          ],
                          attrs: { disabled: _vm.selectedItems.length == 0 },
                          on: {
                            click: function ($event) {
                              return _vm.deleteSelected()
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "trash" } })],
                        1
                      ),
                      _c(
                        "w-button",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: _vm.$ct("manage-views"),
                              expression: "$ct('manage-views')",
                            },
                          ],
                          on: {
                            click: function ($event) {
                              return _vm.manageViews()
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "cogs" } })],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-button",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: _vm.$ct("convert-to-product"),
                          expression: "$ct('convert-to-product')",
                        },
                      ],
                      staticClass: "ml",
                      attrs: { disabled: _vm.addDisabled || _vm.isImporting },
                      on: {
                        click: function ($event) {
                          return _vm.createProducts()
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$ct(
                              !_vm.forSale && _vm.selectedItems.length > 1
                                ? "import-products"
                                : "import-product"
                            )
                          ) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-row",
        { staticClass: "shrink", style: { height: "100%" } },
        [
          _c(
            "w-col",
            { staticClass: "shrink", attrs: { xs: "12" } },
            [
              _c("w-data-table", {
                attrs: {
                  items: _vm.items,
                  "order-column": _vm.orderColumn,
                  "order-directions": _vm.orderAsc,
                  columns: _vm.columns,
                  "selected-items": _vm.selectedItems,
                  "column-resize-handle": "",
                },
                on: {
                  scroll: function ($event) {
                    return _vm.onScroll($event)
                  },
                  order: function ($event) {
                    return _vm.onOrderChanged($event)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("w-row", { staticClass: "bottom" }, [
        _c("div", { staticClass: "root" }, [
          _c("div", { staticClass: "result" }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm.$ctc("components.browse.total", _vm.totalItems, {
                    amount: _vm.totalItems,
                  })
                ) +
                " "
            ),
          ]),
        ]),
      ]),
      _vm.importModalOpen
        ? _c("app-import-csv-modal", {
            on: {
              close: function ($event) {
                _vm.importModalOpen = false
              },
            },
          })
        : _vm._e(),
      _vm.excelMapperOpen
        ? _c("app-excel-mapper", {
            attrs: { service: _vm.PriceListProductService.excelMapperService },
            on: {
              close: function ($event) {
                _vm.excelMapperOpen = false
              },
            },
          })
        : _vm._e(),
      _c(
        "w-modal",
        {
          attrs: { "escape-close": "" },
          model: {
            value: _vm.showContactSearch,
            callback: function ($$v) {
              _vm.showContactSearch = $$v
            },
            expression: "showContactSearch",
          },
        },
        [
          _c(
            "w-card",
            { attrs: { "max-width": "400" } },
            [
              _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("select-supplier")))]),
              _c(
                "w-card-content",
                [
                  _c("app-contact-search", {
                    attrs: {
                      "group-id": [2],
                      "disable-create": "",
                      fancy: "",
                      label: _vm.$ct("select-supplier"),
                      "auto-focus": "",
                    },
                    on: {
                      input: function ($event) {
                        return _vm.onSupplierSelect($event)
                      },
                    },
                    model: {
                      value: _vm.contact,
                      callback: function ($$v) {
                        _vm.contact = $$v
                      },
                      expression: "contact",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-card-actions",
                [
                  _c(
                    "w-button",
                    {
                      staticClass: "cancel",
                      attrs: { icon: "ban" },
                      on: {
                        click: function ($event) {
                          return _vm.closeContactSearch()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.manageViewsModalOpen
        ? _c("app-views-edit-modal", {
            on: {
              close: function ($event) {
                return _vm.onManageViewsModalClosed()
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }